export const apiVersionPrefix = "/api/v0";
export const featureFlagApiPrefix = `${apiVersionPrefix}/featureflags`;
export const killSwicthApiPrefix = `${apiVersionPrefix}/killswitch`;
